<template>
    <div>
        <div class="d-flex">
            <a
                @click="showUserSelector"
                class="btn btn-primary text-white d-flex align-items-center justify-content-center mb-3"
                v-if="currentBooking.booked_as_guest == 'Yes'"
            >
                Link to Customer</a
            >
        </div>
        <div id="user-search" class="modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content tx-size-sm">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title">Please select a user</h4>
                    </div>
                    <div class="modal-body pd-y-20 pd-x-20">
                        <div class="form-group">
                            <label for="">Email:</label> <input type="email" v-model="email" class="form-control" />
                        </div>
                    </div>
                    <div class="border-0 modal-footer pt-0">
                        <button type="button" class="btn ripple btn-primary pd-x-25" data-dismiss="modal" @click="link">
                            Link
                        </button>
                        <button type="button" class="btn ripple btn-light pd-x-25 ml-3" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from '../../apps/shared/vuex/store';

export default {
    name: 'LinkBooking',
    props: ['booking'],
    store,
    data: function () {
        return {
            currentBooking: this.booking,
            email: '',
            selectedUser: null,
        };
    },
    mounted() {
        this.refreshToken();

        setInterval(
            function () {
                this.refreshToken();
            }.bind(this),
            180000
        );
    },
    computed: {
        users() {
            return store.state.users.users;
        },
    },
    methods: {
        refreshToken() {
            store.dispatch('refreshToken');
        },
        showUserSelector() {
            $('#user-search').modal('show');
        },
        hideUserSelector() {
            $('#user-search').modal('hide');
        },
        link() {
            store
                .dispatch('fetchUsers', { email: this.email })
                .then(
                    function (result) {
                        this.assignBooking();
                    }.bind(this)
                )
                .catch(function () {
                    swal('No customer found!', "We couldn't find a user with that email address!", 'error');
                });
        },
        assignBooking() {
            store
                .dispatch('linkQuoteUser', {
                    userId: this.users.id,
                    quoteId: this.booking.quote_id,
                })
                .then(
                    function () {
                        this.currentBooking.booked_as_guest = 'No';
                        swal(
                            'Booking Linked!',
                            'The booking has been assigned to the customer, and their loyalty levels updated!',
                            'success'
                        );
                    }.bind(this)
                )
                .catch(function () {});
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// resources/scripts/portal/components/bookings/LinkBooking.vue